import { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';

const fmt  = v => `R$ ${parseFloat(v||0).toFixed(2).replace('.',',')}`;
const fmtK = v => v >= 1000 ? `R$ ${(v/1000).toFixed(1)}k` : fmt(v);

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    adminAPI.metrics().then(r => setData(r.data.data));
  }, []);

  if (!data) return <div style={{ textAlign:'center',padding:40 }}>Carregando métricas...</div>;

  const cards = [
    { label:'Clientes Ativos',  value: data.tenants?.active   ||0, color:'#059669', bg:'#D1FAE5', icon:'✅' },
    { label:'Em Teste',         value: data.tenants?.trial    ||0, color:'#D97706', bg:'#FEF3C7', icon:'⏳' },
    { label:'Inadimplentes',    value: data.tenants?.overdue  ||0, color:'#DC2626', bg:'#FEE2E2', icon:'⚠️' },
    { label:'Bloqueados',       value: data.tenants?.blocked  ||0, color:'#7C3AED', bg:'#EDE9FE', icon:'🔒' },
    { label:'MRR',              value: fmtK(data.mrr),             color:'#2563EB', bg:'#DBEAFE', icon:'💰' },
    { label:'Receita do Mês',   value: fmtK(data.month_revenue),   color:'#059669', bg:'#D1FAE5', icon:'📈' },
    { label:'Novos este mês',   value: data.new_this_month   ||0,  color:'#0891B2', bg:'#CFFAFE', icon:'🆕' },
    { label:'Total de Clientes',value: data.tenants?.total    ||0,  color:'#374151', bg:'#F3F4F6', icon:'🏢' },
  ];

  return (
    <div>
      <h1 style={{ fontSize:'1.5rem',fontWeight:700,color:'#0F172A',marginBottom:24 }}>Painel Master — AutoFlow</h1>

      <div style={{ display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:16,marginBottom:32 }}>
        {cards.map(c => (
          <div key={c.label} style={{ background:'#fff',border:'1px solid #E5E7EB',borderRadius:12,padding:20 }}>
            <div style={{ display:'flex',justifyContent:'space-between',marginBottom:8 }}>
              <span style={{ fontSize:'.8rem',color:'#6B7280' }}>{c.label}</span>
              <span style={{ fontSize:'1.2rem' }}>{c.icon}</span>
            </div>
            <div style={{ fontSize:'1.6rem',fontWeight:700,color:c.color }}>{c.value}</div>
          </div>
        ))}
      </div>

      {data.plan_stats?.length > 0 && (
        <div style={{ background:'#fff',border:'1px solid #E5E7EB',borderRadius:12,padding:24 }}>
          <h3 style={{ fontWeight:700,marginBottom:16,color:'#0F172A' }}>Distribuição por Plano</h3>
          <div style={{ display:'flex',gap:16,flexWrap:'wrap' }}>
            {data.plan_stats.map(p => (
              <div key={p.name} style={{ background:'#F8FAFC',borderRadius:10,padding:'12px 20px',textAlign:'center' }}>
                <div style={{ fontSize:'1.8rem',fontWeight:700,color:'#2563EB' }}>{p.qty}</div>
                <div style={{ fontSize:'.85rem',color:'#374151',fontWeight:600 }}>{p.name}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
